import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import moment from 'moment';
import { take } from 'rxjs/operators';
import * as i2 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class LastUpdateLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getLastUpdate(visatype, caseType, caseId, sectionCode) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/section/${sectionCode}/audit`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
}
LastUpdateLibraryService.ɵfac = function LastUpdateLibraryService_Factory(t) { return new (t || LastUpdateLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
LastUpdateLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: LastUpdateLibraryService, factory: LastUpdateLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LastUpdateLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LastUpdateLibraryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "label", 4);
    i0.ɵɵtext(3, "Last updated by : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 5);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 3);
    i0.ɵɵelementStart(7, "label", 4);
    i0.ɵɵtext(8, "Last updated on : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "label", 5);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.lastUpdateName);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.lastUpdateDate);
} }
function LastUpdateLibraryComponent_div_1_li_3_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 4);
    i0.ɵɵtext(1, "Assigned To :");
    i0.ɵɵelementEnd();
} }
function LastUpdateLibraryComponent_div_1_li_3_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.inputDetails == null ? null : ctx_r5.inputDetails.assignToEmployeeName);
} }
function LastUpdateLibraryComponent_div_1_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵtemplate(1, LastUpdateLibraryComponent_div_1_li_3_label_1_Template, 2, 0, "label", 11);
    i0.ɵɵtemplate(2, LastUpdateLibraryComponent_div_1_li_3_label_2_Template, 2, 1, "label", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.inputDetails.isPetitionerAction === 1 || ctx_r2.inputDetails.isAttorneyAction === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.inputDetails.isPetitionerAction === 1 || ctx_r2.inputDetails.isAttorneyAction === 1);
} }
function LastUpdateLibraryComponent_div_1_li_4_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 4);
    i0.ɵɵtext(1, "Assigned To :");
    i0.ɵɵelementEnd();
} }
function LastUpdateLibraryComponent_div_1_li_4_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.assignBeneficiary);
} }
function LastUpdateLibraryComponent_div_1_li_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵtemplate(1, LastUpdateLibraryComponent_div_1_li_4_label_1_Template, 2, 0, "label", 11);
    i0.ɵɵtemplate(2, LastUpdateLibraryComponent_div_1_li_4_label_2_Template, 2, 1, "label", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.inputDetails.isBeneficiaryAction === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.inputDetails.isBeneficiaryAction === 1);
} }
function LastUpdateLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementStart(2, "ul", 8);
    i0.ɵɵtemplate(3, LastUpdateLibraryComponent_div_1_li_3_Template, 3, 2, "li", 9);
    i0.ɵɵtemplate(4, LastUpdateLibraryComponent_div_1_li_4_Template, 3, 2, "li", 9);
    i0.ɵɵelementStart(5, "li", 10);
    i0.ɵɵelementStart(6, "label", 4);
    i0.ɵɵtext(7, "Last updated by : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 5);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵelementStart(11, "label", 4);
    i0.ɵɵtext(12, "Last updated on : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "label", 5);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.assignTo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.assignTo);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.lastUpdateName);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.lastUpdateDate);
} }
class LastUpdateLibraryComponent {
    constructor(apiService) {
        this.apiService = apiService;
        this.lastUpdateName = '';
        this.lastUpdateDate = '';
        this.sectionCode = '';
    }
    ngOnChanges(e) {
        // console.log(e);
        if (e.sectionCode && e.sectionCode.currentValue) {
            this.getLastUpdate();
        }
    }
    ngOnInit() {
        var _a, _b;
        if (sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify') == 'CWF') {
            this.isSimplify = true;
            this.assignTo = this.inputDetails.assigneeType ? true : false;
            this.assignBeneficiary = ((_a = this.inputDetails) === null || _a === void 0 ? void 0 : _a.assignToBeneficiaryName) ? (_b = this.inputDetails) === null || _b === void 0 ? void 0 : _b.assignToBeneficiaryName : this.inputDetails.assignToEmployeeName;
        }
        else {
            this.isSimplify = false;
        }
        // - this.getLastUpdate();
    }
    getLastUpdate() {
        if (this.primaryData.visatype || this.primaryData.immigrationCategory) {
            this.apiService.getLastUpdate(this.primaryData.visatype || this.primaryData.immigrationCategory, this.primaryData.caseType, this.primaryData.caseId, this.sectionCode)
                .pipe(take(1))
                .subscribe((response) => {
                if (response) {
                    // console.log('response', response);
                    this.lastUpdateName = response.data.updatedBy ? response.data.updatedBy : '';
                    this.lastUpdateDate = response.data.updatedDate ? moment(response.data.updatedDate).format('MM/DD/YYYY h:mm A') : '';
                }
            });
        }
    }
}
LastUpdateLibraryComponent.ɵfac = function LastUpdateLibraryComponent_Factory(t) { return new (t || LastUpdateLibraryComponent)(i0.ɵɵdirectiveInject(LastUpdateLibraryService)); };
LastUpdateLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LastUpdateLibraryComponent, selectors: [["lib-last-update-library"]], inputs: { inputDetails: "inputDetails", primaryData: "primaryData", sectionCode: "sectionCode" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "row col-md-12 mb-2 p-0 border-top-last-update", 4, "ngIf"], ["class", "row col-md-12 mb-1 p-0 assignMainPortion", 4, "ngIf"], [1, "row", "col-md-12", "mb-2", "p-0", "border-top-last-update"], [1, "col-6", "py-2", "last-modified"], [1, "last-modified-label", "mb-0", "common-bene-class-for-translation"], [1, "last-modified-value", "mb-0", "ml-2"], [1, "row", "col-md-12", "mb-1", "p-0", "assignMainPortion"], [1, "col-12", "assignPortion"], [1, "m-0"], ["class", "pr-2", 4, "ngIf"], [1, "pr-2"], ["class", "last-modified-label mb-0 common-bene-class-for-translation", 4, "ngIf"], ["class", "last-modified-value mb-0 ml-2", 4, "ngIf"]], template: function LastUpdateLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LastUpdateLibraryComponent_div_0_Template, 11, 2, "div", 0);
        i0.ɵɵtemplate(1, LastUpdateLibraryComponent_div_1_Template, 15, 4, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isSimplify);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplify);
    } }, directives: [i2.NgIf], styles: [".last-modified[_ngcontent-%COMP%]{background-color:#f6f6f6;font-size:14px;line-height:5px;height:31px}.last-modified[_ngcontent-%COMP%]   .last-modified-label[_ngcontent-%COMP%]{font:normal normal normal 14px/20px Source Sans Pro;color:#b1b1b1}.last-modified[_ngcontent-%COMP%]   .last-modified-value[_ngcontent-%COMP%]{font:normal normal normal 14px/20px Source Sans Pro;color:#626262}.last-new-modified[_ngcontent-%COMP%]{background-color:#fff;font-size:14px;padding-top:0!important;padding-bottom:0!important}.last-new-modified[_ngcontent-%COMP%]   .last-modified-label[_ngcontent-%COMP%]{font:normal normal normal 14px/20px Source Sans Pro;color:#5a5858;font-size:14px!important}.last-new-modified[_ngcontent-%COMP%]   .last-modified-value[_ngcontent-%COMP%]{font:normal normal normal 14px/20px Source Sans Pro;color:#1c1b1b;font-weight:600;font-size:14px!important}.lastupdate[_ngcontent-%COMP%]{text-align:right}.assignMainPortion[_ngcontent-%COMP%]{border-bottom:1px dashed #ccc;padding:4px 15px;border-top:1px dashed #ccc;background-color:#dedede}.assignPortion[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style:none;padding:0;display:flex;justify-content:flex-end;align-items:center}.assignPortion[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .last-modified-label[_ngcontent-%COMP%], .assignPortion[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .last-modified-value[_ngcontent-%COMP%]{font:normal normal normal 14px/20px Source Sans Pro;color:#2f2f2f;font-size:14px!important}.assignPortion[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .last-modified-value[_ngcontent-%COMP%]{font-weight:600}.border-top-last-update[_ngcontent-%COMP%]{border-top:1px solid #b7b7b7}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LastUpdateLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-last-update-library',
                templateUrl: `./last-update-library.component.html`,
                styleUrls: [`./last-update-library.component.scss`],
            }]
    }], function () { return [{ type: LastUpdateLibraryService }]; }, { inputDetails: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], sectionCode: [{
            type: Input
        }] }); })();

class LastUpdateLibraryModule {
}
LastUpdateLibraryModule.ɵfac = function LastUpdateLibraryModule_Factory(t) { return new (t || LastUpdateLibraryModule)(); };
LastUpdateLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LastUpdateLibraryModule });
LastUpdateLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LastUpdateLibraryModule, { declarations: [LastUpdateLibraryComponent], imports: [PrimengLibraryModule], exports: [LastUpdateLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LastUpdateLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [LastUpdateLibraryComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [LastUpdateLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of last-update-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LastUpdateLibraryComponent, LastUpdateLibraryModule, LastUpdateLibraryService };
//# sourceMappingURL=last-update-library.js.map
